export interface IExternalAction {
  handleAction(payload?: any): Promise<any>;
  messageText?: string;
}

export enum ExternalAction {
  DOWNLOAD = 'download',
  COMPLETEWORKFLOW = 'completeworkflow'
}

export enum WorkflowStatus {
  COMPLETED = 'Completed'
}